import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterCheckBox, FilterCollection, FilterValue, FilterValueCollection } from '@hub/generated/models';

@Component({
  selector: 'f-filterCheckBox',
  templateUrl: './filterCheckBox.component.html',
  styleUrls: ['./filterCheckBox.component.scss']
})
export class FilterCheckBoxComponent implements OnInit {
  @Input()
  public filter: FilterCheckBox;

  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.value = this.getValue();
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Output()
  public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

  public value: boolean;
  public columnName: string;

  public ngOnInit() {
    this.columnName = this.filter.ColumnName;
    this.value = this.getValue();
  }

  public onChange(event) {
    let result: FilterValueCollection = new FilterValueCollection();
    result.ColumnName = this.columnName;
    if (this.value) {
      let filterValue: FilterValue = { Key: '1', Value: null, EntityType: null };
      result.List = [filterValue];
    } else
      result.List = null;

    this.ondataChange.emit(result);
  }

  private getValue(): boolean
  {
    if (!!this.filterCollection && !!this.filterCollection.List) {
      let values = this.filterCollection.List.filter((item) => item.ColumnName == this.columnName)[0];
      if (!!values && !!values.List && !!values.List.length)
        return true;
    }

    return false;
  }
}
